import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, Container } from '@mui/material';
import { setAnalyticsConsent } from '../utils/analytics';

const CONSENT_KEY = 'analytics-consent';

export const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === null) {
      setShowBanner(true);
    } else {
      setAnalyticsConsent(consent === 'true');
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    setAnalyticsConsent(true);
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'false');
    setAnalyticsConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        py: 2,
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: 3,
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderRadius: 2,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
              Cookie Consent
            </Typography>
            <Typography variant="body2" color="text.secondary">
              We use cookies and analytics to improve your experience and understand how you use our site. 
              By clicking "Accept", you consent to our use of cookies and analytics tracking.{' '}
              <a 
                href="/privacy-policy" 
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                Learn more
              </a>
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              flexShrink: 0,
              width: { xs: '100%', md: 'auto' },
            }}
          >
            <Button
              variant="outlined"
              onClick={handleReject}
              sx={{
                flex: { xs: 1, md: 'initial' },
                minWidth: 100,
              }}
            >
              Reject
            </Button>
            <Button
              variant="contained"
              onClick={handleAccept}
              sx={{
                flex: { xs: 1, md: 'initial' },
                minWidth: 100,
                backgroundColor: '#1a1a1a',
                '&:hover': {
                  backgroundColor: '#333333',
                },
              }}
            >
              Accept
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};
